import {useTranslation} from "react-i18next";
import {Box, Button, Typography} from "@mui/material";
import {Link} from "react-router-dom";

const ForbiddenPage = () => {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                textAlign: "center",
                mt: 10,
            }}
        >
            <Typography variant="h3" gutterBottom>
                403
            </Typography>

            <Typography variant="h6" color="text.secondary" gutterBottom>
                {t("forbidden.message")}
            </Typography>

            <Button
                component={Link}
                to="/"
                variant="contained"
                sx={{mt: 3}}
            >
                {t("forbidden.goHome")}
            </Button>
        </Box>
    );
};

export default ForbiddenPage;